import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import ListField from 'views/ListField.js';

const DatePickerDropdownField = ({ future = false, onChange, removable = true, style, value }) => {

    const [day, setDay] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);

    const onClearSelection = () => {

        // update local state values
        setDay(null);
        setMonth(null);
        setYear(null);

        // notify subscriber of data change
        if(typeof(onChange) === 'function') {
            onChange(null);
        }
    }

    const onComponentChange = (key, item) => {

        // declare values for components
        let d = key === 'day' ? item.id : day;
        let m = key === 'month' ? item.id : month;
        let y = key === 'year' ? item.id : year;

        // update local state values
        setDay(d);
        setMonth(m);
        setYear(y);

        // construct date and notify subscribers of date change
        if(d && m && y) {
            let date = moment(`${y}-${m}-${d}`, 'YYYY-MMMM-DD');
            if(typeof(onChange) === 'function') {
                onChange(date);
            }
        }
    }

    const onUpdateValueComponents = () => {
        if(value) {
            let date = moment(value);
            setDay(date.format('D'));
            setMonth(date.format('MMMM'));
            setYear(date.format('YYYY')); 
        }
    }

    const getDayItems = () => {
        let target = month && year ? moment(`${year}-${month}-01`, 'YYYY-MMMM-DD') : moment();
        return [...Array(target.daysInMonth() || 0)].map((_, index) => ({
            id: index + 1,
            title: index + 1
        }));
    }

    const getMonthItems = () => {
        return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(title => ({
            id: title,
            title: title
        }));
    }

    const getYearItems = () => {
        let year = parseInt(moment().format('YYYY'));
        return [...Array(100)].map((_, index) => ({
            id: future ? year + index : year - index,
            title: future ? year + index : year - index
        }));
    }

    const hasValidDate = () => {
        return day && month && year ? true : false;
    }

    useEffect(() => {
        onUpdateValueComponents();
    }, [value]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            ...style
        }}>
            <ListField
            items={getMonthItems()}
            onChange={onComponentChange.bind(this, 'month')}
            placeholder={'Month'}
            style={{
                marginRight: 8
            }}
            value={month} />

            <ListField
            items={getDayItems()}
            onChange={onComponentChange.bind(this, 'day')}
            placeholder={'Day'}
            value={day} />

            <ListField
            items={getYearItems()}
            onChange={onComponentChange.bind(this, 'year')}
            placeholder={'Year'}
            style={{
                marginLeft: 8
            }}
            value={year} />
            {hasValidDate() === true && removable === true && (
                <img
                className={'text-button'}
                onClick={onClearSelection}
                src={'images/delete-red-small.png'}
                style={{
                    height: 25,
                    marginLeft: 8,
                    width: 25
                }} />
            )}
        </div>
    )
}
export default DatePickerDropdownField;
